export default __webpack_public_path__ + "static/media/talk.048a8cdc.svg";